

let env_check = true;//process.env.NODE_ENV === 'production';

let actions = {
    identify: (id) => {
        if (env_check) window.analytics.identify(id);
    },
    alias: (id) => {
        if (env_check) window.analytics.alias(id);
    },
    track: (name, props) => {
        if (env_check) window.analytics.track(name, props);
    },
    people: {
        set: (props) => {
            if (env_check) window.analytics.people.set(props);
        },
    },
};

export let Analytics = actions;


// WEBPACK FOOTER //
// ./src/analytics.js